import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const productService = {
  getAllProducts,
  updateProductStatus,
  getProduct,
  updateProduct,
  createProduct,
  exportProductLists,
  exportProduct,
  createProductHalex,
  updateProductHalex,
  updateProductStatusHalex
};

const MODULE = {
  product: 'rnd-products',
  halex: 'rnd-halex-products',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Product') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllProducts(filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      company: filter.company,
      formulation: filter.formulation,
      class: filter.class,
      moa: filter.moa,
      status: filter.status,
      brand: filter.brand,
      shell_life_time: filter.shelfLifeTime,
      rnd_product_ai: filter.productAI,
      rnd_product_source: filter.productSource,
      brand_name: filter.brandName,
      lrmp: filter.lrmp,
      reference_number: filter.referenceNumber,
      dor_start: filter.dorStart,
      dor_end: filter.dorEnd,
      expired_date_start: filter.expiredDateStart,
      expired_date_end: filter.expiredDateEnd,
      dossier_submission_date_start: filter.dossierSubmissionDateStart,
      dossier_submission_date_end: filter.dossierSubmissionDateEnd,
      approval_date_start: filter.approvalDateStart,
      approval_date_end: filter.appriovalDateEnd,
      shelf_life_production: filter.shelfLifeProduction,
      // is_registration_certificated: filter.isRegisterCert,
      is_active: filter.isActive,
      is_from_halex: filter.isFromHalex,
      rnd_product_label_images: filter.productLabel,
    }
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return await apiHelper(API_URL).get(`/${MODULE.product}`, requestOptions)
}


export function updateProductStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.product}/${data.id}`, requestOptions)
}

export function updateProductStatusHalex(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.halex}/${data.id}`, requestOptions)
}

export function getProduct(id) {
  return apiHelper(API_URL).get(`/${MODULE.product}/${id}/show`)
}

export function updateProduct(data) {

  const requestOptions = {
    company_uuid: data.companyID,
    formulation_uuid: data.formulationID,
    class_uuid: data.classID,
    // moa_uuid: data.moaID,
    type_uuid: data.typeID,
    purpose_uuid: data.purposeID,
    status_uuid: data.statusID,
    brand_name: data.brandName,
    lrmp: data.lrmp,
    reference_number: data.referenceNumber,
    dor: data.dor,
    expired_date: data.expiredDate,
    dossier_subission_date: data.dorSubmissionDate,
    remark: data.remark,
    approval_date: data.approvalDate,
    is_registration_certificated: data.isRegisterCert,
    shelf_life_production: data.shelfLifeProduction,
    shell_life_time: data.shelfLifeTime,
    endorse_label: data.endorseLabel,
  }

  return apiHelper(API_URL).put(`/${MODULE.product}/${data.id}`, requestOptions)
}

export function updateProductHalex(data) {

  const requestOptions = {
    formulation_uuid: data.formulationID,
    class_uuid: data.classID,
    moa_uuid: data.moaID,
    type_uuid: data.typeID,
    purpose_uuid: data.purposeID,
    status_uuid: data.statusID,
    brand_name: data.brandName,
    lrmp: data.lrmp,
    reference_number: data.referenceNumber,
    dor: data.dor,
    expired_date: data.expiredDate,
    dossier_subission_date: data.dorSubmissionDate,
    remark: data.remark,
    approval_date: data.approvalDate,
    is_registration_certificated: data.isRegisterCert,
    shelf_life_production: data.shelfLifeProduction,
    shell_life_time: data.shelfLifeTime,
    endorse_label: data.endorseLabel,
  }

  return apiHelper(API_URL).put(`/${MODULE.halex}/${data.id}`, requestOptions)
}

export function createProduct(data) {
  const requestOptions = {
    company_uuid: data.companyID,
    formulation_uuid: data.formulationID,
    class_uuid: data.classID,
    // moa_uuid: data.moaID,
    type_uuid: data.typeID,
    purpose_uuid: data.purposeID,
    brand_name: data.brandName,
    lrmp: data.lrmp,
    reference_number: data.referenceNumber,
    dor: data.dor,
    expired_date: data.expiredDate,
    dossier_subission_date: data.dorSubmissionDate,
    remark: data.remark,
    approval_date: data.approvalDate,
    is_registration_certificated: data.isRegisterCert,
    shelf_life_production: data.shelfLifeProduction,
    shell_life_time: data.shelfLifeTime,
    endorse_label: data.endorseLabel,
  }

  return apiHelper(API_URL).post(`/${MODULE.product}`, requestOptions)
}

export function createProductHalex(data) {
  const requestOptions = {
    formulation_uuid: data.formulationID,
    class_uuid: data.classID,
    // moa_uuid: data.moaID,
    type_uuid: data.typeID,
    purpose_uuid: data.purposeID,
    brand_name: data.brandName,
    lrmp: data.lrmp,
    reference_number: data.referenceNumber,
    dor: data.dor,
    expired_date: data.expiredDate,
    dossier_subission_date: data.dorSubmissionDate,
    remark: data.remark,
    approval_date: data.approvalDate,
    is_registration_certificated: data.isRegisterCert,
    shelf_life_production: data.shelfLifeProduction,
    shell_life_time: data.shelfLifeTime,
    endorse_label: data.endorseLabel,
  }

  return apiHelper(API_URL).post(`/${MODULE.product}`, requestOptions)
}

export function exportProductLists(filter) {
  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      company: filter.company,
      formulation: filter.formulation,
      class: filter.class,
      // moa: filter.moa,
      status: filter.status,
      type: filter.type,
      rnd_product_ai: filter.productAI,
      rnd_product_source: filter.productSource,
      brand_name: filter.brandName,
      lrmp: filter.lrmp,
      reference_number: filter.referenceNumber,
      dor_start: filter.dorStart,
      dor_end: filter.dorEnd,
      expired_date_start: filter.expiredDateStart,
      expired_date_end: filter.expiredDateEnd,
      dossier_submission_date_start: filter.dossierSubmissionDateStart,
      dossier_submission_date_end: filter.dossierSubmissionDateEnd,
      approval_date_start: filter.approvalDateStart,
      approval_date_end: filter.appriovalDateEnd,
      shelf_life_production: filter.shelfLifeProduction,
      is_registration_certificated: filter.isRegisterCert,
      is_active: filter.isActive,
      is_export_all: filter.isExportAll == true ? 1 : 0
    }
  }

  if (filter.selectedColumns.length > 0) {
    let array = filter.selectedColumns
    array.forEach((word, index) => {
      if (word != null || word != '') {
        var searchParam = `selected_columns[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return apiHelper(API_URL).get(`/${MODULE.product}/export/list`, requestOptions)
}

export function exportProduct(id) {
  return apiHelper(API_URL).get(`/${MODULE.product}/export/${id}/data`)
}